import $ from "jquery";
import "jquery-validation";
import { showSnackbar } from '../common/snackBar';
export function initSubscribeEmailForm(): void {
    const _form = $('#SubscribeEmailForm');

    // Validation
    const _validator = _form.validate({
        ignore: ':hidden',
        errorPlacement: function (error, element) {
            if (element.attr("name") === "RequiresEmailSignup") {
                error.appendTo('#checkboxErrorPlacement');
            } else {
                error.appendTo('#emailValidationMsg');
            }
            return true;
        },
        rules: {
            'SubscriptionEmail': {
                required: true,
                email: true
            },
            'RequiresEmailSignup': {
                required: true
            }
        }
    });

    // Submit Button
    $('#btnSubmitEmailSubscribeForm').on('click', function (e) {
        e.preventDefault();
        $('#btnSubmitEmailSubscribeForm').attr("disabled", "true");

        if (_validator.form()) {
            const token = $('input[name="__RequestVerificationToken"]').val() as string;
            $.ajax({
                type: 'POST',
                data: {
                    '__RequestVerificationToken': token,
                    'subscribeEmail': $("#SubscriptionEmail").val()
                },
                url: '/Account/CustomerSubscribe',
                success: function () {
                    showSnackbar(undefined, window._screenMessages.SubscribeSuccess);
                    $('#btnSubmitEmailSubscribeForm').removeAttr("disabled");
                },
                error: function () {
                    showSnackbar(undefined, window._screenMessages.SubscribeError);
                    $('#btnSubmitEmailSubscribeForm').removeAttr("disabled");
                },
                complete: function () {
                    $('#btnSubmitEmailSubscribeForm').removeAttr("disabled");
                }
            });
        } else {
            $('#btnSubmitEmailSubscribeForm').removeAttr("disabled");
        }
    });
}